export const useNotificationStore = defineStore('notification', () => {
    const unread_counts = ref(null)

    return { unread_counts }
})
